import type { FC } from "react";
import { Box } from "@mui/material";
import type { RegistrationStatus } from "../api/registrations.types";
import { statusColors } from "./RegistrationStatus";

export const RegistrationStatusDot: FC<{ status: RegistrationStatus["status"] }> = ({ status }) => {
  return (
    <Box sx={{ flexShrink: 0, bgcolor: statusColors[status].dot, height: "9px", width: "9px", borderRadius: "3px" }} />
  );
};
